module.exports = __webpack_public_path__ + "media/images/pc/visit_reservations_enpou/main_visual-01161da6bb4c88e1c6c191a2740680dc.jpg";